module.exports = __webpack_public_path__ + "img/chris (27).296f4434.jpg";